import {PetitionCampaignDTO} from "./types";
import axios from 'axios';
export function setupHandraiserReactions(campaign: PetitionCampaignDTO) {
    return {
        reactions: {
            page: 1,
            more: campaign.comments.more,
            fromId: campaign.comments.fromId,
        },
        loadMoreReactions: {
            ['@click.prevent'](e) {
                e.preventDefault();
                this.reactions.page++;
                axios.get(`/petitions/${campaign.petition.slug}/comments`, {
                    params: {
                        page: this.reactions.page,
                        fromId: this.reactions.fromId,
                    }
                })
                    .then(response => {
                        this.$refs.reactions.innerHTML += response.data.html;
                        this.reactions.more = response.data.more;
                    })
                    .catch(response => {
                        console.error(response.data);
                    });
            }
        },
    };
}
